




















import { Component } from 'vue-property-decorator';
import MerchantListItem from '@/components/merchant-list/MerchantListItem.vue';

@Component
export default class MerchantPopover extends MerchantListItem {
}
